import * as React from 'react'
import {FC, useEffect} from 'react'
import Form from 'antd/lib/form'
import {Col, Row} from 'antd/lib/grid'
import 'antd/lib/grid/style'
import useController from '../../hooks/use-controller'
import Step from '../../../../common/components/step'
import TripParams from '../trip-params'
import Filling from '../filling'
import DataAndPayment from '../data-and-payment'
import Header from '../../../../common/components/header'
import {COMPONENT_SIZE, HEADER_STEPS} from '../../constants'
import GlobalOptionsInterface from '../../types/global-options'
import CheckWrapper from '../../../../common/components/check-wrapper'
import Check from '../check'
import './index.less'
import CheckCost from '../../../../common/components/check-cost'
import addTestPayment from '../../../../common/helpers/add-test-payment'
import ControlBlockModeSwitch from '../control-block-mode-switch'
import useModals from '../../hooks/use-modals'
import useInitialValues from '../../hooks/use-initial-values'

interface CalculatorPropsInterface {
    globalOptions: GlobalOptionsInterface
}

const Calculator: FC<CalculatorPropsInterface> = ({globalOptions}) => {
    const {
            form,
            currentStep,
            cost,
            policy,
            paymentLink,
            prevStep,
            recalculate,
            bonusesSystemIsOn,
            handleNextClick,
            sendPaymentLink,
            handleSendPaymentLinkToEmail,
        } = useController({globalOptions}),
        nextDisabled =
            cost.requestStatus === 'started' ||
            policy.requestStatus === 'started' ||
            paymentLink.requestStatus === 'started'

    // @ts-ignore
    window.eform = form
    const initialValues = useInitialValues(globalOptions.initialValues)
    useModals(cost, policy, sendPaymentLink)

    useEffect(() => {
        addTestPayment(globalOptions)
    }, [])

    return (
        <Form
            className={'e-calc'}
            layout={'vertical'}
            form={form}
            name={'main'}
            initialValues={initialValues}
            size={COMPONENT_SIZE}
        >
            <Row gutter={64}>
                <Col xs={24} sm={24} md={{span: 24, order: 0}}>
                    <Header currentStep={currentStep} calcSteps={HEADER_STEPS} />
                </Col>
                <Col xs={24} md={{span: 14, order: 1}}>
                    <Step hidden={currentStep !== 0}>
                        <TripParams form={form} />
                    </Step>
                    <Step hidden={currentStep !== 1}>
                        <Filling
                            form={form}
                            cost={cost.data === null ? 0 : cost.data.totalRub}
                            globalOptions={globalOptions}
                            onValueChange={recalculate}
                            bonusesSystemIsOn={bonusesSystemIsOn}
                        />
                    </Step>
                    <Step hidden={currentStep !== 2}>
                        <DataAndPayment form={form} />
                    </Step>
                </Col>
                <Col xs={24} sm={24} md={{span: 14, order: 3}}>
                    <ControlBlockModeSwitch
                        mode={globalOptions.calcMode}
                        currentStep={currentStep}
                        onNextClick={handleNextClick}
                        onPrevClick={prevStep}
                        nextDisabled={nextDisabled}
                        onSendPaymentLinkToEmail={handleSendPaymentLinkToEmail}
                    />
                </Col>
                <Col xs={24} md={{span: 10, order: 2}}>
                    <CheckWrapper rootNodeId={globalOptions.rootNodeId} currentStep={currentStep}>
                        <Check cost={cost} />
                        <CheckCost
                            currentStep={currentStep}
                            cost={cost.data === null ? 0 : cost.data.totalRub}
                            defaultCost={'от 68'}
                            loadingCost={cost.requestStatus === 'started'}
                            bonusesSystemIsOn={bonusesSystemIsOn}
                            rootNodeId={globalOptions.rootNodeId}
                            onPrevStepClick={prevStep}
                        />
                    </CheckWrapper>
                </Col>
            </Row>
            {/*{ENV_IS_DEV ? (*/}
            {/*    <>*/}
            {/*        <button*/}
            {/*            onClick={e => {*/}
            {/*                e.preventDefault()*/}
            {/*                // e.stopPropagation()*/}
            {/*                console.log(form.getFieldsValue())*/}
            {/*                console.log(globalOptions)*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            Данные*/}
            {/*        </button>*/}
            {/*        <button*/}
            {/*            onClick={() => {*/}
            {/*                form.setFieldsValue({*/}
            {/*                    insureds: [{birthday: moment('1995-12-01')}],*/}
            {/*                })*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            s*/}
            {/*        </button>*/}
            {/*    </>*/}
            {/*) : null}*/}
        </Form>
    )
}

export default Calculator
